/*! facett renewal — STORY & GUIDE
 * PC: Recommended 同型スライダー（開始揃え＋左右覗き見）
 * SP: 縦積み（Swiper なし）
 * Hero 非干渉: data-facett-story のみ
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var MQ_PC = '(min-width: 768px)';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function isPc() {
    return window.matchMedia(MQ_PC).matches;
  }

  function readCssPx(root, prop, fallback) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(' + prop + ')';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || fallback;
  }

  function getCardW(root) {
    return readCssPx(root, '--facett-story-card-w', 712);
  }

  function getGap(root) {
    return readCssPx(root, '--facett-story-gap', 16);
  }

  function getInsetPx(root) {
    return readCssPx(root, '--facett-story-inset', 0);
  }

  function getContentMax(root) {
    return readCssPx(root, '--facett-story-content', 1440);
  }

  function getContentOffset(root, el) {
    if (!el) return 40;

    var ref = document.querySelector(
      '.facett-pickup__grid, .facett-material__grid, .facett-category__grid'
    );
    if (ref) {
      var refLeft = Math.round(ref.getBoundingClientRect().left);
      var elLeft = Math.round(el.getBoundingClientRect().left);
      var delta = refLeft - elLeft;
      if (delta !== 0) return Math.max(0, delta);
      if (refLeft > 1) return 0;
    }

    var vw = window.innerWidth || document.documentElement.clientWidth;
    var inset = getInsetPx(root);
    var content = getContentMax(root);
    return Math.max(inset, Math.round((vw - content) / 2));
  }

  function needsSwipe(el, slideCount, offsetBefore, offsetAfter, cardW, gap) {
    if (!el || slideCount <= 1) return false;
    var w = cardW || 712;
    var g = gap || 16;
    var total =
      slideCount * w + Math.max(0, slideCount - 1) * g + (offsetBefore || 0) + (offsetAfter || 0);
    return total > el.clientWidth + 1;
  }

  function destroyStory(root) {
    if (!root) return;
    if (root._facettStorySwiper && typeof root._facettStorySwiper.destroy === 'function') {
      try {
        root._facettStorySwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettStorySwiper = null;
    root.dataset.facettStoryReady = '';
  }

  function setStack(root, on) {
    root.classList.toggle('facett-story--stack', !!on);
  }

  function setStatic(root, on) {
    root.classList.toggle('facett-story--static', !!on);
  }

  function initStory(root) {
    if (!root) return;

    var el = root.querySelector('[data-facett-story-swiper]');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;

    destroyStory(root);
    setStatic(root, false);
    setStack(root, false);

    if (count <= 1) {
      root.classList.add('facett-story--single');
      setStack(root, !isPc());
      setStatic(root, true);
      root.dataset.facettStoryReady = '1';
      return;
    }

    root.classList.remove('facett-story--single');

    /* SP: 常に縦積み */
    if (!isPc()) {
      setStack(root, true);
      setStatic(root, true);
      root.dataset.facettStoryReady = '1';
      return;
    }

    var cardW = getCardW(root);
    var gap = getGap(root);
    var offsetBefore = getContentOffset(root, el);
    var offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(root), 24));

    if (!needsSwipe(el, count, offsetBefore, offsetAfter, cardW, gap)) {
      setStatic(root, true);
      root.dataset.facettStoryReady = '1';
      return;
    }

    if (!window.Swiper) return;

    offsetBefore = getContentOffset(root, el);
    offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(root), 24));

    root._facettStorySwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: gap,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: offsetAfter,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      a11y: {
        enabled: true,
      },
    });

    if (root._facettStorySwiper.isLocked) {
      destroyStory(root);
      setStatic(root, true);
    }

    root.dataset.facettStoryReady = '1';
  }

  function anyNeedsPcSwipe(roots) {
    if (!isPc()) return false;
    return Array.prototype.some.call(roots, function (root) {
      var el = root.querySelector('[data-facett-story-swiper]');
      if (!el) return false;
      var count = el.querySelectorAll('.swiper-slide').length;
      if (count <= 1) return false;
      var before = getContentOffset(root, el);
      var after = Math.min(before, Math.max(getInsetPx(root), 24));
      return needsSwipe(el, count, before, after, getCardW(root), getGap(root));
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-story]').forEach(function (root) {
      initStory(root);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-story]');
    if (!roots.length) return;

    if (anyNeedsPcSwipe(roots)) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(syncAll);
        })
        .catch(function () {
          syncAll();
        });
      return;
    }

    syncAll();
    window.requestAnimationFrame(syncAll);
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-story]');
    if (root) {
      destroyStory(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-story]');
    if (root) {
      destroyStory(root);
    }
  });
})();
